const config = {
  mainTitle: 'Change Logs',
  subHeading: 'View and manage your logs here',
  titleIcon: 'IosFiling'
}

export default config
